module.exports = __webpack_public_path__ + "static/people-fe0bd514ee50c61d7f97bccc40ab58b0.png";